import {getPublicAssetUrl} from '@jobseeker/common-core/utils';
import NextImage, {ImageProps as NextImageProps} from 'next/image';

export interface ImageProps extends Omit<NextImageProps, 'src' | 'width' | 'height'> {
  src: string | any;
  useCdn?: boolean;
  isPublicAsset?: boolean;
  width?: string | number;
  height?: string | number;
}

const extractNumericValue = (value: string | number | undefined): number | undefined => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const match = value.match(/(\d+(?:\.\d+)?)/);
    return match ? parseFloat(match[1]) : undefined;
  }
  return undefined;
};

export const Image: React.FC<ImageProps> = ({src, useCdn, style, ...props}) => {
  let imageSrc = src;
  if (typeof src === 'string') {
    try {
      const shouldUseCdn =
        useCdn !== undefined
          ? useCdn
          : !src?.includes('http://') &&
            !src?.includes('https://') &&
            !src?.includes('data:');
      imageSrc = shouldUseCdn ? getPublicAssetUrl(src) : src;
      // console.log('imagesrc', imageSrc, shouldUseCdn);
    } catch (error) {}
  }
  const customStyle: React.CSSProperties = {
    ...style,
    ...(props.width && { width: props.width }),
    ...(props.height && { height:props.height }),
  };
  const numericWidth = extractNumericValue(props.width);
  const numericHeight = extractNumericValue(props.height);
  if ((numericWidth && numericHeight)||props.fill||props.objectFit||props.layout) {
    return (
      <NextImage 
        data-test-id="lotus-image" 
        src={imageSrc} 
        {...props} 
        width={numericWidth}
        height={numericHeight}
        style={customStyle} 
        
      />
    );
  } else {
    if(imageSrc && imageSrc.src){
      imageSrc = imageSrc.src;
    }
    // Use regular img tag when no dimensions specified
    return (
      <img 
        data-test-id="lotus-image-fallback" 
        src={imageSrc} 
        style={customStyle}
        {...(props as any)}
      />
    );
  }
};

export default Image;
